import ProjectCard from '../components/ProjectCard';

function Projects() {
  return (
    <section className="py-16 pt-24 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-navy text-center mb-12 animate-fade-in">Our Projects</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <ProjectCard
            title="City Bridge Restoration"
            description="Restored a historic bridge with eco-friendly coatings, completed in 2024."
            image="/img/bridge-project.jpeg"
          />
          <ProjectCard
            title="Municipal Water Tower"
            description="Applied high-performance coatings to a 100ft water tower in 2023."
            image="/img/water-tower-project.jpeg"
          />
          <ProjectCard
            title="Office Complex Facade"
            description="Transformed a commercial building with modern finishes in 2025."
            image="/img/commercial-project.jpeg"
          />
        </div>
      </div>
    </section>
  );
}

export default Projects;